import React from 'react';
import RangeInput from '../../common/RangeInput';
import {Box} from '@mui/material';
import {useSplitContext} from 'providers/SplitProvider';

const TimeInputSlider = (props: TimeInputSliderProps) => {
  const {maxTime} = useSplitContext();

  const max = React.useMemo(() => Math.max(maxTime / 1000, 0.001), [maxTime]);
  const [value, setValue] = React.useState(0);

  const handleChange = (value: number) => {
    if (props.disabled) return;
    setValue(value);
    return props.onChange(value * 1000);
  };

  React.useEffect(() => {
    setValue(props.value / 1000);
  }, [props.value]);

  return (
    <Box sx={{position: 'relative', width: '100%'}}>
      <RangeInput min={0} max={max} onChange={handleChange} value={Math.min(value, max)} compact={props.compact} />
    </Box>
  );
};

export default TimeInputSlider;

type TimeInputSliderProps = {
  value: number;
  onChange: (value: number) => void;
  compact?: boolean;
  disabled?: boolean;
};
